import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

const CLASS_NAV_OPEN = 'has-nav-open';
const CLASS_NAV_SCROLL = 'has-nav-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.isAvailable = true;

        this.bindkeydown = this.keydown.bind(this);
        window.addEventListener('keydown',this.bindkeydown);
    }

    scrollTrigger(e) {
        // console.log(e);

        // if(e.direction == 'down') {
        //     html.classList.add(CLASS_NAV_SCROLL);
        // } 
        
        // if(e.direction == 'up' && e.mode == 'leave'){
        //     html.classList.remove(CLASS_NAV_SCROLL);
        // }
    }

    trigger(e) {
        if(html.classList.contains(CLASS_NAV_OPEN)) {
            this.close();
        } else {
            this.open();
        }
    }

    close() {
        if(!this.isAvailable) return;
        html.classList.remove(CLASS_NAV_OPEN);

        this.isAvailable = false;
        gsap.delayedCall(1.2,() => {
            this.isAvailable = true;
        })
    }

    open() {
        if(!this.isAvailable) return;
        html.classList.add(CLASS_NAV_OPEN);

        this.isAvailable = false;
        gsap.delayedCall(1.2,() => {
            this.isAvailable = true;
        })
    }

    keydown(e) {
        if(e.key == 'Escape') {
            this.close();
        }
    }

    destroy() {
        window.removeEventListener('keydown',this.bindkeydown);

    }
}
